import { useState, useEffect } from 'react';
import { getReporteRemanente, TicketRemanente } from '../../../../service/reportes/ReporteRemanente';

export function useReporteRemanente(ids_dia: number[], reload: number) {
  const [list, setList] = useState<TicketRemanente[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (ids_dia.length === 0) {
      setList([]);
      return;
    }
    setLoading(true);
    getReporteRemanente(ids_dia)
      .then(setList)
      .catch(() => setList([]))
      .finally(() => setLoading(false));
  }, [ids_dia.join(','), reload]); // eslint-disable-line react-hooks/exhaustive-deps

  return { list, loading };
}
